import { createPinia } from "pinia";
import { createApp } from "vue";

import App from "@/App.vue";
import { registerServiceWorker } from "@/pwa/registerServiceWorker";
import { useNotificationsStore } from "@/stores/notifications";
import "@/styles/main.css";

const app = createApp(App);

app.use(createPinia());

app.config.errorHandler = (error, _instance, info) => {
  // Dernier filet : une erreur de rendu ne doit jamais laisser un écran blanc
  // sans trace exploitable.
  console.error(`[album] erreur de rendu (${info})`, error);
};

app.mount("#app");

// Une mise à jour n'est jamais appliquée d'autorité : recharger sous les pieds
// de l'invité interromprait un enregistrement vocal ou un ajout en cours.
registerServiceWorker(() => {
  useNotificationsStore().notify(
    "Une nouvelle version de l’album est prête. Rechargez la page pour en profiter.",
  );
});
